import { Languages } from '../languages'

export enum ChangelogMessages {
  NEW = 'NEW',
  UPDATES = 'UPDATES',
  BUGFIX = 'BUG_FIX',
  CHANGEDATE1 = 'CHANGE_DATE_1',
  CHANGEDATE2 = 'CHANGE_DATE_2',
  CHANGEDATE3 = 'CHANGE_DATE_3',
  CHANGEDATE4 = 'CHANGE_DATE_4',
  CHANGEDATE5 = 'CHANGE_DATE_5',
  CHANGEDATE6 = 'CHANGE_DATE_6',
  CHANGEDATE7 = 'CHANGE_DATE_7',
  CHANGEDATE8 = 'CHANGE_DATE_8',
  CHANGEDATE9 = 'CHANGE_DATE_9',
  CHANGEDATE10 = 'CHANGE_DATE_10',
  CHANGEDATE11 = 'CHANGE_DATE_11',
  CHANGEDATE12 = 'CHANGE_DATE_12',
  CHANGEDATE13 = 'CHANGE_DATE_13',
  CHANGEDATE14 = 'CHANGE_DATE_14',
  CHANGEDATE15 = 'CHANGE_DATE_15',
  CHANGEDATE16 = 'CHANGE_DATE_16',
  CHANGEDATE17 = 'CHANGE_DATE_17',
  CHANGEDATE18 = 'CHANGE_DATE_18',
  CHANGEDATE19 = 'CHANGE_DATE_19',
  CHANGEDATE20 = 'CHANGE_DATE_20',
  CHANGEDATE1_INFO1 = 'CHANGEDATE1_INFO1',
  CHANGEDATE1_INFO2 = 'CHANGEDATE1_INFO2',
  CHANGEDATE2_INFO1 = 'CHANGEDATE2_INFO1',
  CHANGEDATE3_INFO1 = 'CHANGEDATE3_INFO1',
  CHANGEDATE4_INFO1 = 'CHANGEDATE4_INFO1',
  CHANGEDATE4_INFO2 = 'CHANGEDATE4_INFO2',
  CHANGEDATE5_INFO1 = 'CHANGEDATE5_INFO1',
  CHANGEDATE5_INFO2 = 'CHANGEDATE5_INFO2',
  CHANGEDATE6_INFO1 = 'CHANGEDATE6_INFO1',
  CHANGEDATE6_INFO2 = 'CHANGEDATE6_INFO2',
  CHANGEDATE7_INFO1 = 'CHANGEDATE7_INFO1',
  CHANGEDATE7_INFO2 = 'CHANGEDATE7_INFO2',
  CHANGEDATE8_INFO1 = 'CHANGEDATE8_INFO1',
  CHANGEDATE8_INFO2 = 'CHANGEDATE8_INFO2',
  CHANGEDATE9_INFO1 = 'CHANGEDATE9_INFO1',
  CHANGEDATE10_INFO1 = 'CHANGEDATE10_INFO1',
  CHANGEDATE10_INFO2 = 'CHANGEDATE10_INFO2',
  CHANGEDATE10_INFO3 = 'CHANGEDATE10_INFO3',
  CHANGEDATE11_INFO1 = 'CHANGEDATE11_INFO1',
  CHANGEDATE12_INFO1 = 'CHANGEDATE12_INFO1',
  CHANGEDATE12_INFO2 = 'CHANGEDATE12_INFO2',
  CHANGEDATE12_INFO3 = 'CHANGEDATE12_INFO3',
  CHANGEDATE12_INFO4 = 'CHANGEDATE12_INFO4',
  CHANGEDATE12_INFO5 = 'CHANGEDATE12_INFO5',
  CHANGEDATE13_INFO1 = 'CHANGEDATE13_INFO1',
  CHANGEDATE13_INFO2 = 'CHANGEDATE13_INFO2',
  CHANGEDATE13_INFO3 = 'CHANGEDATE13_INFO3',
  CHANGEDATE13_INFO4 = 'CHANGEDATE13_INFO4',
  CHANGEDATE13_INFO5 = 'CHANGEDATE13_INFO5',
  CHANGEDATE13_INFO6 = 'CHANGEDATE13_INFO6',
  CHANGEDATE13_INFO7 = 'CHANGEDATE13_INFO7',
  CHANGEDATE13_INFO8 = 'CHANGEDATE13_INFO8',
  CHANGEDATE13_INFO9 = 'CHANGEDATE13_INFO9',
  CHANGEDATE13_INFO10 = 'CHANGEDATE13_INFO10',
  CHANGEDATE13_INFO11 = 'CHANGEDATE13_INFO11',
  CHANGEDATE13_INFO12 = 'CHANGEDATE13_INFO12',
  CHANGEDATE14_INFO1 = 'CHANGEDATE14_INFO1',
  CHANGEDATE15_INFO1 = 'CHANGEDATE15_INFO1',
  CHANGEDATE16_INFO1 = 'CHANGEDATE16_INFO1',
  CHANGEDATE17_INFO1 = 'CHANGEDATE17_INFO1',
  CHANGEDATE18_INFO1 = 'CHANGEDATE18_INFO1',
  CHANGEDATE18_INFO2 = 'CHANGEDATE18_INFO2',
  CHANGEDATE19_INFO1 = 'CHANGEDATE19_INFO1',
  CHANGEDATE20_INFO1 = 'CHANGEDATE20_INFO1',
}

export type IncludedChangelogMessages = {
  [P in ChangelogMessages]: {
    [P in Languages]: string
  }
}

export const translatedChangelogMessages: IncludedChangelogMessages = {
  [ChangelogMessages.NEW]: {
    en: 'New'
  },

  [ChangelogMessages.UPDATES]: {
    en: 'Updates'
  },

  [ChangelogMessages.BUGFIX]: {
    en: 'Bug Fixes'
  },

  [ChangelogMessages.CHANGEDATE1]: {
    en: '17.10.23'
  },

  [ChangelogMessages.CHANGEDATE2]: {
    en: '31.10.23'
  },

  [ChangelogMessages.CHANGEDATE3]: {
    en: '06.11.23'
  },

  [ChangelogMessages.CHANGEDATE4]: {
    en: '05.12.23'
  },

  [ChangelogMessages.CHANGEDATE5]: {
    en: '13.12.23'
  },

  [ChangelogMessages.CHANGEDATE6]: {
    en: '10.01.24'
  },

  [ChangelogMessages.CHANGEDATE7]: {
    en: '09.02.24'
  },

  [ChangelogMessages.CHANGEDATE8]: {
    en: '11.03.24'
  },

  [ChangelogMessages.CHANGEDATE9]: {
    en: '14.03.24'
  },

  [ChangelogMessages.CHANGEDATE10]: {
    en: '25.06.24'
  },

  [ChangelogMessages.CHANGEDATE11]: {
    en: '03.07.24'
  },

  [ChangelogMessages.CHANGEDATE12]: {
    en: '10.07.24'
  },

  [ChangelogMessages.CHANGEDATE13]: {
    en: '28.08.24'
  },

  [ChangelogMessages.CHANGEDATE14]: {
    en: '18.10.24'
  },

  [ChangelogMessages.CHANGEDATE15]: {
    en: '20.10.24'
  },

  [ChangelogMessages.CHANGEDATE16]: {
    en: '01.11.24'
  },

  [ChangelogMessages.CHANGEDATE17]: {
    en: '05.02.25'
  },

  [ChangelogMessages.CHANGEDATE18]: {
    en: '26.02.25'
  },

  [ChangelogMessages.CHANGEDATE19]: {
    en: '20.03.25'
  },

  [ChangelogMessages.CHANGEDATE20]: {
    en: '31.03.25'
  },

  [ChangelogMessages.CHANGEDATE1_INFO1]: {
    en: 'Endpoint /price-areas: Provides a list of price areas and hourly consumption aggregates for each of the price areas under open Dataset consumption_per_group_mba_hour.'
  },

  [ChangelogMessages.CHANGEDATE1_INFO2]: {
    en: 'Added /consumption-groups endpoint to share list of all available consumption groups.'
  },

  [ChangelogMessages.CHANGEDATE2_INFO1]: {
    en: 'Endpoint /price-areas (consumption_per_group_mba_hour dataset): "meteringPointCount" param is added under consumptionPerGroupMbaHour to provide number of metering points in each aggregations.'
  },

  [ChangelogMessages.CHANGEDATE3_INFO1]: {
    en: 'Endpoint /metering-points: Provides information about a metering point.'
  },

  [ChangelogMessages.CHANGEDATE4_INFO1]: {
    en: 'Added open Dataset production_per_group_mba_hour under /price-areas to share hourly Production aggregates for each of the price areas.'
  },

  [ChangelogMessages.CHANGEDATE4_INFO2]: {
    en: 'Endpoint /production-groups: Provides a list of available production groups.'
  },

  [ChangelogMessages.CHANGEDATE5_INFO1]: {
    en: 'Endpoint /grid-areas: Provides a list of grid areas.'
  },

  [ChangelogMessages.CHANGEDATE5_INFO2]: {
    en: 'Endpoint /parties: Provides a list of parties.'
  },

  [ChangelogMessages.CHANGEDATE6_INFO1]: {
    en: 'Endpoint /municipalities: Provides a list of municipalities.'
  },

  [ChangelogMessages.CHANGEDATE6_INFO2]: {
    en: 'Added dataset consumption_per_group_municipality_hour under /municipalities to offer hourly consumption aggregates per municipality.'
  },

  [ChangelogMessages.CHANGEDATE7_INFO1]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_group_mba_nace_code_hour under /municipalities to serve protected consumption aggregates.'
  },

  [ChangelogMessages.CHANGEDATE7_INFO2]: {
    en: 'Updated API docs to provide details about the relationship between Datasets and their respective production/consumption groups.'
  },

  [ChangelogMessages.CHANGEDATE8_INFO1]: {
    en: 'Added Open Dataset production_per_metering_point_type_municipality_hour under /municipalities to provide production aggregates.'
  },

  [ChangelogMessages.CHANGEDATE8_INFO2]: {
    en: 'Description of endpoints are moved from Swagger to Overview section in API docs page'
  },

  [ChangelogMessages.CHANGEDATE9_INFO1]: {
    en: 'Added Open Dataset consumption_per_group_mga_hour under /grid-areas to provide consumption aggregates.'
  },

  [ChangelogMessages.CHANGEDATE10_INFO1]: {
    en: 'Added Open Dataset exchange_per_mba_hour under /price-areas to provide exchange aggregates.'
  },

  [ChangelogMessages.CHANGEDATE10_INFO2]: {
    en: 'Added Open Dataset loss_per_mba_hour under /price-areas to provide loss aggregates.'
  },

  [ChangelogMessages.CHANGEDATE10_INFO3]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_mba_mga_municipality_nace_code_consumption_code_hour under /municipalities to serve protected consumption aggregates.'
  },

  [ChangelogMessages.CHANGEDATE11_INFO1]: {
    en: 'Added Open Dataset consumption_per_group_municipality_basic_statistical_unit_hour under /municipalities to provide consumption aggregates.'
  },

  [ChangelogMessages.CHANGEDATE12_INFO1]: {
    en: 'Added Open Dataset loss_per_mga_hour under /grid-areas to provide loss aggregates for regional and distribution grid areas.'
  },

  [ChangelogMessages.CHANGEDATE12_INFO2]: {
    en: 'Added Maskinporten Protected Dataset exchange_per_mga_hour_restricted under /grid-areas to provide exchange aggregates.'
  },

  [ChangelogMessages.CHANGEDATE12_INFO3]: {
    en: 'Added Maskinporten Protected Dataset loss_per_mga_hour_restricted under /grid-areas to provide loss aggregates.'
  },

  [ChangelogMessages.CHANGEDATE12_INFO4]: {
    en: 'Renaming Dataset consumption_per_mba_municipality_nace_code_hour under /municipalities to consumption_per_mba_municipality_nace_code_hour_restricted.'
  },

  [ChangelogMessages.CHANGEDATE12_INFO5]: {
    en: 'Renaming Dataset consumption_per_mba_mga_municipality_nace_code_consumption_code_hour under /municipalities to consumption_per_mba_mga_municipality_nace_code_consumption_code_hour_restricted.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO1]: {
    en: 'Added Open Dataset completeness_daily_per_mba under /price-areas to provide completeness report for price areas.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO2]: {
    en: 'Added Maskinporten Protected Dataset completeness_daily_per_balance_supplier_mba_restricted under /price-areas to provide completeness report for price areas per balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO3]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_balance_supplier_mba_hour_restricted under /price-areas to provide consumption aggregate for price areas per balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO4]: {
    en: 'Added Maskinporten Protected Dataset production_per_balance_supplier_metering_point_type_mba_hour_restricted under /price-areas to provide production aggregate for price areas per metering point and balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO5]: {
    en: 'Added Open Dataset completeness_daily_per_mga under /grid-areas to provide completeness report for grid areas.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO6]: {
    en: 'Added Maskinporten Protected Dataset completeness_daily_per_balance_supplier_mga_restricted under /grid-areas to provide completeness report for grid areas per balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO7]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_balance_supplier_mga_hour_restricted under /grid-areas to provide consumption aggregate for grid areas per balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO8]: {
    en: 'Added Maskinporten Protected Dataset production_per_balance_supplier_metering_point_type_mga_hour_restricted under /grid-areas to provide production aggregate for grid areas per metering point and balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO9]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_mba_municipality_nace_code_consumption_code_hour_restricted under /municipalities to provide weighted consumption aggregates.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO10]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_balance_supplier_municipality_hour_restricted under /municipalities to provide consumption aggregate for municipalities per balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO11]: {
    en: 'Added Maskinporten Protected Dataset production_per_balance_supplier_metering_point_type_municipality_hour_restricted under /municipalities to provide production aggregate for municipalities per metering point and balance supplier.'
  },

  [ChangelogMessages.CHANGEDATE13_INFO12]: {
    en: 'Added CSV export functionality for the some datasets in /price-areas, /grid-areas and /municipalities'
  },

  [ChangelogMessages.CHANGEDATE14_INFO1]: {
    en: 'Added Maskinporten Protected Dataset production_per_balance_supplier_metering_point_type_code_mba_hour_restricted under /price-areas to provide to production aggregates per balance supplier and price area.'
  },

  [ChangelogMessages.CHANGEDATE15_INFO1]: {
    en: 'Added Maskinporten Protected Dataset metering_point_missing_reads_per_mga_daily_restricted under /grid-areas to provide to missing reads per grid area.'
  },

  [ChangelogMessages.CHANGEDATE16_INFO1]: {
    en: 'Added Maskinporten Protected Dataset metering_values_hour_restricted under /metering-points to provide to metering values for an end-user.'
  },

  [ChangelogMessages.CHANGEDATE17_INFO1]: {
    en: 'Added Maskinporten Protected Dataset consumption_per_hour_balance_supplier_group_mga_consumption_type_code_restricted under /grid-areas to provide to consumption aggregates per balance supplier and grid area.'
  },

  [ChangelogMessages.CHANGEDATE18_INFO1]: {
    en: 'Added Open Dataset installed_capacity_per_metering_point_type_group_municipality_daily, installed_capacity_per_metering_point_type_group_municipality_basic_statistical_unit_daily under /municipalities to provide to installed capacity per municipalities.'
  },

  [ChangelogMessages.CHANGEDATE18_INFO2]: {
    en: 'Added Open Dataset installed_capacity_per_metering_point_type_group_mba_daily under /price-areas to provide to installed capacity per price area.'
  },

  [ChangelogMessages.CHANGEDATE19_INFO1]: {
    en: 'Added Maskinporten Protected Dataset Dataset production_per_hour_balance_supplier_group_metering_point_type_mga_restricted under /grid-areas to provide production aggregates per balance supplier and grid area.'
  },

  [ChangelogMessages.CHANGEDATE20_INFO1]: {
    en: 'Added Open Dataset max_consumption_per_eac_municipality_basic_statistical_unit_month under /municipalities to provide max consumption / EAC for a given hour in the month for municipality and basic statistical unit.'
  }

}
